// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// react-flatpickr components
import Flatpickr from "react-flatpickr";

// react-flatpickr styles
import "flatpickr/dist/flatpickr.css";

// components
import SoftInput from "components/SoftInput";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";
function SoftDatePicker({ input, options, ...rest }) {
  return (
    <Flatpickr
      options={{
        locale: Vietnamese,
        time_24hr: true,
        dateFormat: rest?.dateFormat ?? "d-m-Y",
        enableTime: true,
        plugins: [
          new confirmDatePlugin({
            dateFormat: rest?.dateFormat ?? "d-m-Y",
          }),
        ],
        ...options,
      }}
      {...rest}
      render={({ defaultValue }, ref) => (
        <SoftInput {...input} defaultValue={defaultValue} inputRef={ref} />
      )}
    />
  );
}

// Setting default values for the props of SoftDatePicker
SoftDatePicker.defaultProps = {
  input: {},
};

// Typechecking props for the SoftDatePicker
SoftDatePicker.propTypes = {
  input: PropTypes.objectOf(PropTypes.any),
  options: PropTypes.any,
};

export default SoftDatePicker;
